// === GESTIONNAIRE DE SKILLS DE COMBAT ===
// Helpers purs pour composer la liste des skills actifs d'un combattant
// selon sa classe. Extrait de CombatScene pour être testable et garantir
// que le skill de classe est inclus dès le premier combat.

import { BASE_SKILLS, CLASS_SKILLS } from '../constants';
import { SurvivorClass } from './CampManager';
import { SkillDefinition } from '../types/Combat.types';

/**
 * Retourne la liste de skills actifs pour une classe donnée :
 * 3 skills de base + 1er skill de classe (si la classe en a un).
 *
 * Bug fix : avant cette extraction, le skill de classe pouvait manquer
 * lors du tout premier combat car CombatScene initialisait `activeSkills`
 * avec BASE_SKILLS uniquement, AVANT que la classe soit connue.
 */
export function getActiveSkillsForClass(cls: SurvivorClass): SkillDefinition[] {
  const classSkillList = CLASS_SKILLS[cls] ?? [];
  return [
    ...BASE_SKILLS,
    ...(classSkillList.length > 0 ? [classSkillList[0]] : []),
  ];
}
